import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { slugs } from '../Constant/slugs';
import '../styles.css'
import { MainUrl, sideBarImage } from '../Constant/api';
import Database from '../Constant/database.json'

const SideBarBlock = ({
  allSlug, newSlug, location,
  Title, icon, setExpand, Expand,
  setMenuExpand
}) => {
  return (
    <div>
      <div className={location.pathname == allSlug ? "row active-sidebar" : "row passive-sidebar"}>
        <Link className={"Link col-10"} to={allSlug}>
          <div className={location.pathname == allSlug ? "active-sidebar-font" : "passive-sidebar-font"}
            onClick={() => {
              setMenuExpand(false)
            }}
          >
            &nbsp; &nbsp;{Title}
          </div>
        </Link>
        {newSlug !== "" &&
          <div className="col-1" style={{ cursor: 'pointer' }}
            onClick={() => {
              setExpand(!Expand)
            }}>
            <i className={Expand ? "fa fa-minus" : "fa fa-plus"} style={{ fontSize: "10px" }} />
          </div>
        }
      </div>
      {Expand && newSlug !== "" &&
        <>
          <Link className={location.pathname == allSlug ? "Link active-sidebar" : "Link passive-sidebar"}
            style={{ paddingLeft: "40px" }}
            to={allSlug}
          >
            <div className={location.pathname == allSlug ? "Link active-sidebar-font" : "Link passive-sidebar-font"}>
              All {Title}
            </div>
          </Link>
          <Link className={location.pathname == `/${newSlug}` ? "Link active-sidebar" : "Link passive-sidebar"}
            style={{ paddingLeft: "40px" }}
            to={newSlug}
          >
            <div className={location.pathname == `/newSlug` ? "active-sidebar-font" : "passive-sidebar-font"}>
              Add New {Title.slice(0, -1)}
            </div>
          </Link>
        </>
      }
    </div>
  )
}
export default function SideBar({ setMenuExpand }) {
  const LoginUser = useSelector((state) => state.LoginState);
  const [Menu, setMenu] = React.useState(false)
  const location = useLocation()

  const [ExamExpand, setExamExpand] = React.useState(false)
  const [BuyExamExpand, setBuyExamExpand] = React.useState(false)
  const [DemoExamExpand, setDemoExamExpand] = React.useState(false)
  const [DailyExamExpand, setDailyExamExpand] = React.useState(false)
  const [ChapterWiseExamExpand, setChapterWiseExamExpand] = React.useState(false)
  const [BookExpand, setBookExpand] = React.useState(false)
  const [StudentExpand, setStudentExpand] = React.useState(false)
  const [TeacherExpand, setTeacherExpand] = React.useState(false)
  const [BatchExpand, setBatchExpand] = React.useState(false)
  const [ChapterExpand, setChapterExpand] = React.useState(false)
  const [DailyResultsExpand, setDailyResultsExpand] = React.useState(false)
  const [ExamResultsExpand, setExamResultsExpand] = React.useState(false)

  const type_array = {
    "ubt": "ubt",
    "chapter_exam": "chapter-exam",
    "japanese": "japanese",
    "bridge_course": "bridge-course",
    "lok_sewa": "lok-sewa",
    "german": "german",
    "herbrew": "herbrew"
  }
  return (
    <div>
      <div className="small-display-none">
        <div style={{ justifyContent: 'center', display: 'flex', padding: "30px", borderBottom: "1px solid #eee" }}>
          <img
            src={sideBarImage}
            style={{ width: "200px", height: "100px", objectFit: 'contain' }}
          />
        </div>
      </div>

      <div className="small-display-block">
        <div className="row passive-sidebar" onClick={() => { setMenuExpand(false) }}>
          <div className={"passive-sidebar-font"}>
            <i className="fa fa-close" style={{ fontSize: "16px" }} />&nbsp; &nbsp;Close
          </div>
        </div>
      </div>
      {/* Home */}
      {/* {LoginUser.userRole} */}
      {(LoginUser.userRole == "author") &&
        <>
          <SideBarBlock
            allSlug={`${slugs.all_exam}/${type_array.ubt}`} newSlug={`${slugs.new_exam}/${type_array.ubt}`}
            location={location} Title={"Exams"}
            icon={""}
            Expand={ExamExpand}
            setExpand={setExamExpand}
          />
          <SideBarBlock
            allSlug={`${slugs.all_category}`} newSlug={`${slugs.new_category}`}
            location={location} Title={"Category"}
            icon={""}
            setExpand={setChapterWiseExamExpand} Expand={ChapterWiseExamExpand}
            setMenuExpand={setMenuExpand}
          />
          <SideBarBlock
            allSlug={slugs.all_batch} newSlug={slugs.new_batch}
            location={location} Title={"Batches"}
            icon={""}
            setExpand={setChapterExpand} Expand={ChapterExpand}
            setMenuExpand={setMenuExpand}
          />
          <SideBarBlock
            allSlug={slugs.all_chapter} newSlug={slugs.new_chapter}
            location={location} Title={"Classes"}
            icon={""}
            setExpand={setChapterExpand} Expand={ChapterExpand}
            setMenuExpand={setMenuExpand}
          />
          {/* <SideBarBlock
            allSlug={slugs.all_written_exam} newSlug={slugs.new_written_exam}
            location={location} Title={"Written Exam"}
            icon={""}
            setExpand={setChapterExpand} Expand={ChapterExpand}
            setMenuExpand={setMenuExpand}
          />
           <SideBarBlock
            allSlug={slugs.all_written_exam_results} newSlug={slugs.new_written_exam_results}
            location={location} Title={"Written Exam Results"}
            icon={""}
            setExpand={setChapterExpand} Expand={ChapterExpand}
            setMenuExpand={setMenuExpand}
          /> */}
          {/* <SideBarBlock
            allSlug={slugs.nagarpalika_details} newSlug={""}
            location={location} Title={"Nagarpalika"}
            icon={""}
            setExpand={setChapterExpand} Expand={ChapterExpand}
            setMenuExpand={setMenuExpand}
          /> */}
          {/* <SideBarBlock
            allSlug={slugs.all_chapter} newSlug={slugs.new_chapter}
            location={location} Title={"Demo Class"}
            icon={""}
            setExpand={setChapterExpand} Expand={ChapterExpand}
            setMenuExpand={setMenuExpand}
          /> */}
          {/* <SideBarBlock
            allSlug={slugs.all_books} newSlug={slugs.new_book}
            location={location} Title={"All Books"}
            icon={""}
            setExpand={setBookExpand} Expand={BookExpand}
            setMenuExpand={setMenuExpand}
          /> */}
          {/* <SideBarBlock
            allSlug={`${slugs.all_exam}`} newSlug={`${slugs.new_exam}`}
            location={location} Title={"Exams"}
            icon={""}
            Expand={ExamExpand}
            setExpand={setExamExpand}
          /> */}
          {/* <SideBarBlock
            allSlug={`${slugs.all_exam}/1053`} newSlug={`${slugs.new_exam}`}
            location={location} Title={"Question Bank"}
            icon={""}
            Expand={ExamExpand}
            setExpand={setExamExpand}
          /> */}
          {/* <SideBarBlock
            allSlug={`${slugs.all_exam}/${type_array.lok_sewa}`} newSlug={`${slugs.new_exam}/${type_array.lok_sewa}`}
            location={location} Title={"Loksewa"}
            icon={""}
            Expand={ExamExpand}
            setExpand={setExamExpand}
          /> */}
          {/* <SideBarBlock
            allSlug={slugs.all_demo_exam} newSlug={slugs.new_demo_exam}
            location={location} Title={"Demo Exams"}
            icon={""}
            setExpand={setDemoExamExpand}
            Expand={DemoExamExpand}
            setMenuExpand={setMenuExpand}
          /> */}
          {/* <SideBarBlock
            allSlug={`${slugs.all_exam}/${type_array.chapter_exam}`} newSlug={`${slugs.new_exam}/${type_array.chapter_exam}`}
            location={location} Title={"Chapter Exams"}
            icon={""}
            setExpand={setChapterWiseExamExpand} Expand={ChapterWiseExamExpand}
            setMenuExpand={setMenuExpand}
          /> */}

          {/* {LoginUser.userRole == "author" &&
            <SideBarBlock
              allSlug={slugs.all_teachers} newSlug={slugs.new_teacher}
              location={location} Title={"Class Test"}
              icon={""}
              setExpand={setTeacherExpand} Expand={TeacherExpand}
              setMenuExpand={setMenuExpand}
            />
          } */}
          {/* <SideBarBlock
            allSlug={"/Images"} newSlug={""}
            location={location} Title={"Orientation"}
            icon={""}
            Expand={DemoExamExpand}
            setExpand={setDemoExamExpand}
          /> */}
          {/* <SideBarBlock
            allSlug={"/AllRegistration"} newSlug={""}
            location={location} Title={"All Registrations"}
            icon={""}
            Expand={DemoExamExpand}
            setExpand={setDemoExamExpand}
          /> */}

          {/* <SideBarBlock
            allSlug={`/Account`} newSlug={``}
            location={location} Title={"Account"}
            icon={""}
            Expand={ExamExpand}
            setExpand={setExamExpand}
          /> */}


          {/* <SideBarBlock
            allSlug={slugs.all_daily_results} newSlug={""}
            location={location} Title={"Batch Results"}
            icon={""}
            setExpand={setDailyExamExpand} Expand={BookExpand}
            setMenuExpand={setMenuExpand}
          /> */}
          {/* <SideBarBlock
            allSlug={slugs.all_results} newSlug={""}
            location={location} Title={"Exam Results"}
            icon={""}
            setExpand={setBookExpand} Expand={BookExpand}
            setMenuExpand={setMenuExpand}
          /> */}
          {/* <SideBarBlock
            allSlug={slugs.all_notice} newSlug={slugs.new_notice}
            location={location} Title={"Notice"}
            icon={""}
            setExpand={setBookExpand} Expand={BookExpand}
            setMenuExpand={setMenuExpand}
          /> */}
          {/* <SideBarBlock
            allSlug={slugs.all_chapter_results} newSlug={""}
            location={location} Title={"Chapter Results"}
            icon={""}
            setExpand={setBookExpand} Expand={BookExpand}
            setMenuExpand={setMenuExpand}
          /> */}
          {LoginUser.userRole == "author" &&
            <>
              <SideBarBlock
                allSlug={slugs.all_students} newSlug={slugs.new_student}
                location={location} Title={"Users"}
                icon={""}
                setExpand={setStudentExpand} Expand={StudentExpand}
                setMenuExpand={setMenuExpand}
              />
              <SideBarBlock
                allSlug={slugs.all_nfdin_students} newSlug={slugs.new_nfdin_student}
                location={location} Title={"NFDIN"}
                icon={""}
                setExpand={setStudentExpand} Expand={StudentExpand}
                setMenuExpand={setMenuExpand}
              />
              <SideBarBlock
                allSlug={"/nfdin-attendance"} newSlug={""}
                location={location} Title={"Attendance"}
                icon={""}
                setExpand={setStudentExpand} Expand={StudentExpand}
                setMenuExpand={setMenuExpand}
              />
              <SideBarBlock
                allSlug={"/written-paper"} newSlug={""}
                location={location} Title={"Written Paper"}
                icon={""}
                setExpand={setStudentExpand} Expand={StudentExpand}
                setMenuExpand={setMenuExpand}
              />
            </>
          }
          <div className="row active-sidebar">
            Student Panel
          </div>
        </>
      }

      {(LoginUser.userRole == "creater") &&
        <>
          <SideBarBlock
            allSlug={slugs.all_institute_daily_exam} newSlug={""}
            location={location} Title={"Exams Entry"}
            icon={""}
            setExpand={setDailyExamExpand} Expand={DailyExamExpand}
          />
          <SideBarBlock
            allSlug={slugs.all_institute_books} newSlug={""}
            location={location} Title={"Books Entry"}
            icon={""}
            setExpand={setDailyExamExpand} Expand={DailyExamExpand}
          />
          <SideBarBlock
            allSlug={slugs.all_institute_chapters} newSlug={""}
            location={location} Title={"Class Entry"}
            icon={""}
            setExpand={setDailyExamExpand} Expand={DailyExamExpand}
          />
          <SideBarBlock
            allSlug={"/AllRegistration"} newSlug={""}
            location={location} Title={"All Registrations"}
            icon={""}
            Expand={DemoExamExpand}
            setExpand={setDemoExamExpand}
          />
          <SideBarBlock
            allSlug={slugs.all_students} newSlug={slugs.new_student}
            location={location} Title={"Users"}
            icon={""}
            setExpand={setStudentExpand} Expand={StudentExpand}
            setMenuExpand={setMenuExpand}
          />
          <SideBarBlock
            allSlug={slugs.all_institute_teacher} newSlug={""}
            location={location} Title={"Class Test"}
            icon={""}
            setExpand={setDailyExamExpand} Expand={DailyExamExpand}
          />


        </>
      }
      {LoginUser.userRole == "orientation_officer" &&
        <>
          <SideBarBlock
            allSlug={"/Images"} newSlug={""}
            location={location} Title={"Orientation"}
            icon={""}
            Expand={DemoExamExpand}
            setExpand={setDemoExamExpand}
          />
          <SideBarBlock
            allSlug={"/AllRegistration"} newSlug={""}
            location={location} Title={"All Registrations"}
            icon={""}
            Expand={DemoExamExpand}
            setExpand={setDemoExamExpand}
          />
          <SideBarBlock
            allSlug={slugs.all_students} newSlug={slugs.new_student}
            location={location} Title={"Users"}
            icon={""}
            setExpand={setStudentExpand} Expand={StudentExpand}
            setMenuExpand={setMenuExpand}
          />
          <SideBarBlock
            allSlug={`/Account`} newSlug={``}
            location={location} Title={"Account"}
            icon={""}
            Expand={ExamExpand}
            setExpand={setExamExpand}
          />

        </>
      }
      <div className={"row passive-sidebar"}>
        <a className={"Link col-10"} href={MainUrl}>
          <div className={"passive-sidebar-font"}
            onClick={() => {
              setMenuExpand(false)
            }}
          >
            &nbsp; &nbsp;Home
          </div>
        </a>
      </div>
      <SideBarBlock
        allSlug={"/"} newSlug={""}
        location={location} Title={"Dashboard"}
        icon={""}
        setExpand={setBookExpand} Expand={BookExpand}
        setMenuExpand={setMenuExpand}
      />
      {/* <SideBarBlock
        allSlug={slugs.exam} newSlug={""}
        location={location} Title={"All Exam "}
        icon={""}
        setExpand={setBookExpand} Expand={BookExpand}
        setMenuExpand={setMenuExpand}
      /> */}
      <SideBarBlock
        allSlug={"/classroom"} newSlug={""}
        location={location} Title={"Classroom"}
        icon={""}
        setExpand={setBookExpand} Expand={BookExpand}
        setMenuExpand={setMenuExpand}
      />
      <SideBarBlock
        allSlug={slugs.courses_list} newSlug={""}
        location={location} Title={"Courses"}
        icon={""}
        setExpand={setBookExpand} Expand={BookExpand}
        setMenuExpand={setMenuExpand}
      />
      <SideBarBlock
        allSlug={slugs.free_courses_list} newSlug={""}
        location={location} Title={"Free Courses"}
        icon={""}
        setExpand={setBookExpand} Expand={BookExpand}
        setMenuExpand={setMenuExpand}
      />
      <SideBarBlock
        allSlug={slugs.demo_exam} newSlug={""}
        location={location} Title={"Demo Exam"}
        icon={""}
        setExpand={setBookExpand} Expand={BookExpand}
        setMenuExpand={setMenuExpand}
      />
      <SideBarBlock
        allSlug={"/profile"} newSlug={""}
        location={location} Title={"Profile"}
        icon={""}
        setExpand={setBookExpand} Expand={BookExpand}
        setMenuExpand={setMenuExpand}
      />
    </div>
  )
}